export default {
  url: "QueryRetailerShippingLocations.json",
  fields:
    "RetailerId,Id,Name,Address,Address2,City,State,Zip,Country,Phone,SalesRep1,SalesRep2,SalesRep3,SalesRep4,SalesRep5,DefaultShipOn,StoreClass,StoreCategory,ShippingMethod,Status,LocationEmail,ContactName,Reason,Custom2,LocationEmail",
  pageSize: 24,
  sortBy: "Name,Id",
  append: false,
  autoLoad: true,
  disableQueryString: false,
  views: {
    list: "th-list",
    cards: "th",
  },
  filters: [
    { groupBy: "Status" },
    { text: "RetailerId", title: "Customer ID" },
    { text: "NameStartsWith", title: "Ship Name" },
    { text: "IdStartsWith", title: "Ship Id" },
    { groupBy: "State" },
    { text: "ZipStartsWith", title: "Ship Id" },
  ],
  hideLeftNav: true,
  sortOptions: {
    Id: "Ship Id: Low to High",
    "-Id": "Ship Id: High to Low",
    "Name,Id": "Ship Name: A to Z",
    "-Name,Id": "Ship Name: Z to A",
    "RetailerId,Id": "Customer ID: High to Low",
    "-RetailerId,Id": "Customer ID: Low to High",
    "Address,Id": "Address: A to Z",
    "-Address,Id": "Address: Z to A",
    "City,Id": "City: A to Z",
    "-City,Id": "City: Z to A",
    "State,Id": "State: A to Z",
    "-State,Id": "State: Z to A",
    "Zip,Id": "Zip: 1 to 9",
    "-Zip": "Zip: 9 to 1",
    "Status,Id": "Status: A to Z",
    "-Status,Id": "Status: Z to A",
  },
};
